import { PhoneNumber } from 'utils';
import * as Yup from 'yup';

const telephoneReview = {
  telephone: Yup.string()
    .required("Écrivez NULL dans le champ si vous n'avez pas le téléphone")
    .test(
      'partial-telephone',
      'Entrer un téléphone valide ou NULL si pas de téléphone',
      async (telephoneValue) => {
        if (telephoneValue === 'NULL') {
          return true;
        }

        const isTelephone = Yup.string()
          .required()
          .test(
            'is-valid',
            'Numéro de téléphone invalide !',
            PhoneNumber.isValid,
          )
          .validate(telephoneValue, { strict: true })
          .then(() => true)
          .catch(() => false);

        return isTelephone;
      },
    ),
};

const emailReview = {
  email: Yup.string()
    .required("Écrivez NULL dans le champ si vous n'avez pas l'email")
    .test(
      'partial-email',
      "Entrer un email valide ou NULL si pas d'email",
      async (emailValue) => {
        if (emailValue === 'NULL') {
          return true;
        }

        const isEmailValid = await Yup.string()
          .required()
          .email()
          .validate(emailValue, { strict: true })
          .then(() => true)
          .catch(() => false);

        return isEmailValid;
      },
    ),
};

const rating = {
  rating: Yup.number()
    .required('La note est requise !')
    .integer('La note doit correspondre à un chiffre entier entre 1 et 5')
    .max(5, 'La note doit être inférieure ou égale à 5')
    .min(1, 'La note doit être supérieure ou égale à 1'),
};

export const proReviewFormValidationSchema = (hasReply: boolean) =>
  Yup.object().shape({
    reviewAspect: Yup.string().required('La nature de la prestation requise !'),
    reviewBody: Yup.string().required('Commentaire requis !'),
    comment: Yup.string(),
    reply: hasReply ? Yup.string().required('Réponse requise !') : Yup.string(),
    cityId: Yup.number().nullable().required('Lieu de la prestation requis !'),
    givenName: Yup.string().required('Prénom requis !'),
    familyName: Yup.string().required('Nom requis !'),
    dateOfWork: Yup.date().required('La date des travaux est requise !'),
    source: Yup.string().when('isExternalSource', {
      is: true,
      then: (schema) => schema.required('Source requise !'),
      otherwise: (schema) => schema.default(''),
    }),
    ...rating,
    ...emailReview,
    ...telephoneReview,
  });
